export default __webpack_public_path__ + "static/media/error-image.980a8f38.png";